// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return, prefer-const */

import _ from "lodash";
import type { AerialPlotResponse, Option } from "./types";
import type { TrialAnalysisDataOptions, TrialData, UserClientAssociations } from "./types/trialTypes";

//@ts-expect-error
const aerialApiUri: string = process.env.aerialPlotConnections.aerialPlotApi.baseUrl;

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getTrialSearchDataOptions(clientId, searchAllClients, accessToken) {
	return fetch(
		`${aerialApiUri}api/v1/Trials/TrialSearchDataOptions?clientId=${clientId}&searchAllClients=${searchAllClients}`,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	)
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getTrialFavorites(clientId, accessToken) {
	return fetch(`${aerialApiUri}api/v1/Trials/GetTrialFavorites?clientId=${clientId}`, {
		method: "GET",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getTrialFavoriteGuids(clientId, accessToken) {
	return fetch(`${aerialApiUri}api/v1/Trials/GetTrialFavoriteGuids?clientId=${clientId}`, {
		method: "GET",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getRecentlyPublishedTrials(clientId, accessToken) {
	return fetch(`${aerialApiUri}api/v1/Trials/GetRecentlyPublishedTrials?clientId=${clientId}`, {
		method: "GET",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function createTrialFavorite(clientId, accessToken, trialId) {
	return fetch(`${aerialApiUri}api/v1/Trials/CreateTrialFavorite?clientId=${clientId}&trialId=${trialId}`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${accessToken}`,
		},
		body: JSON.stringify(trialId),
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function deleteTrialFavorite(clientId, accessToken, trialId) {
	return fetch(`${aerialApiUri}api/v1/Trials/DeleteTrialFavorite?clientId=${clientId}&trialId=${trialId}`, {
		method: "DELETE",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getTrialAnalysisDataOptions(clientId, trialId, accessToken) {
	return fetch(`${aerialApiUri}api/v1/Trials/TrialAnalysisDataOptions?clientId=${clientId}&trialId=${trialId}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getRecentlyUpdatedTrials(clientId, accessToken) {
	return fetch(`${aerialApiUri}api/v1/Trials/GetRecentlyUpdatedTrials?clientId=${clientId}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getSummaryTableDataOptions(clientId, trialId, accessToken) {
	return fetch(`${aerialApiUri}api/v1/Trials/SummaryTableDataOptions?clientId=${clientId}&trialId=${trialId}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function searchForTrials(searchParams, clientId, searchAllClients, accessToken) {
	return fetch(
		`${aerialApiUri}api/v1/Trials/SearchForTrials?clientId=${clientId}&plantDateFrom=${searchParams.plantDateFrom}&plantDateTo=${searchParams.plantDateTo}&searchAllClients=${searchAllClients}`,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	)
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getTrialsInField(fieldId, clientId, accessToken) {
	return fetch(`${aerialApiUri}api/v1/Trials/TrialsInField?fieldId=${fieldId}&clientId=${clientId}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getTrialHeatmapData(clientId, trialId, accessToken) {
	return fetch(aerialApiUri + `api/v1/Trials/GetTrialHeatmapData?clientId=${clientId}&trialId=${trialId}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getTrialOptions(clientId, trialId, accessToken) {
	return fetch(`${aerialApiUri}api/v1/Trials/getTrialOptions?clientId=${clientId}&trialId=${trialId}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getTrialOutlineData(clientId, trialId, accessToken) {
	return fetch(aerialApiUri + `api/v1/Trials/GetTrialOutlineData?clientId=${clientId}&trialId=${trialId}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

export function getTrialData(clientId: string, trialId: string, accessToken: string): Promise<AerialPlotResponse<any>> {
	return fetch(aerialApiUri + `api/v1/Trials?clientId=${clientId}&trialId=${trialId}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function saveAssessmentSelectionForSummaryTable(summaryTableSelectionData, accessToken, clientId, trialId) {
	const flightSelectionFormData = new FormData();
	let index = 0;
	for (const selection of summaryTableSelectionData) {
		if (selection.assessments?.length > 0) {
			for (const assessment of selection.assessments) {
				if (assessment.enabled) {
					if (assessment.type != "grounddata") {
						flightSelectionFormData.append(`Selections[${index}].AnalysisTypeId`, selection.id);
						flightSelectionFormData.append(`Selections[${index}].FlightId`, assessment.id);
						flightSelectionFormData.append(`Selections[${index}].GroundDataAssessmentId`, "");
						flightSelectionFormData.append(`Selections[${index}].GroundDataSetId`, "");
					} else {
						flightSelectionFormData.append(
							`Selections[${index}].GroundDataAssessmentId`,
							assessment.groundDataAssessmentId,
						);
						flightSelectionFormData.append(`Selections[${index}].GroundDataSetId`, assessment.id);
						flightSelectionFormData.append(`Selections[${index}].FlightId`, "");
						flightSelectionFormData.append(`Selections[${index}].AnalysisTypeId`, "");
					}
					flightSelectionFormData.append(`Selections[${index}].AnalysisId`, "");
					flightSelectionFormData.append(`Selections[${index}].CurveModelAnalysisId`, "");
					flightSelectionFormData.append(`Selections[${index}].ClientId`, clientId);
					flightSelectionFormData.append(`Selections[${index}].TrialId`, trialId);
					flightSelectionFormData.append(`Selections[${index}].Enabled`, assessment.enabled);
					flightSelectionFormData.append(`Selections[${index}].Checked`, assessment.checked);
					flightSelectionFormData.append(
						`Selections[${index}].QuantifiedRegionTypeId`,
						selection.quantifiedRegionTypeOptionId ?? "",
					);
					index++;
				}
			}
		} else if (selection.curveModelAnalysisId) {
			flightSelectionFormData.append(`Selections[${index}].AnalysisTypeId`, selection.analysisTypeId);
			flightSelectionFormData.append(`Selections[${index}].FlightId`, "");
			flightSelectionFormData.append(`Selections[${index}].GroundDataAssessmentId`, "");
			flightSelectionFormData.append(`Selections[${index}].GroundDataSetId`, "");
			flightSelectionFormData.append(`Selections[${index}].AnalysisId`, selection.analysisId);
			flightSelectionFormData.append(`Selections[${index}].CurveModelAnalysisId`, selection.curveModelAnalysisId);
			flightSelectionFormData.append(`Selections[${index}].ClientId`, clientId);
			flightSelectionFormData.append(`Selections[${index}].TrialId`, trialId);
			flightSelectionFormData.append(`Selections[${index}].Enabled`, selection.enabled);
			flightSelectionFormData.append(`Selections[${index}].Checked`, selection.checked);
			index++;
		}
	}

	return fetch(`${aerialApiUri}api/v1/Trials/AssessmentSelectionForSummaryTable`, {
		method: "PUT",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
		body: flightSelectionFormData,
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function updateTrial(trial, accessToken) {
	const trialFormData = new FormData();
	for (const name in trial) {
		if (name !== "treatments") {
			let val = trial[name] === "" ? null : trial[name];

			//-- Need to specifically check for the name isEstimatedPlantDate because it has the word "date" in it but it should not be treated as a date
			if (name.match(/date/gim) && name !== "isEstimatedPlantDate" && val) {
				val = val.toLocaleDateString();
			}

			if (val) {
				if (typeof val === "string") val = val?.trim();
				trialFormData.set(name, val);
			}
		}
	}

	return fetch(`${aerialApiUri}api/v1/Trials`, {
		method: "PUT",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
		body: trialFormData,
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

// export function updateTrialTreatments(treatments, clientId, accessToken) {
// 	let index = 0;
// 	const treatmentFormData = new FormData();

// 	for (const tr of treatments) {
// 		treatmentFormData.append(`Treatments[${index}].TreatmentId`, tr.treatmentId);
// 		treatmentFormData.append(`Treatments[${index}].TrialTreatmentId`, tr.trialTreatmentId);
// 		treatmentFormData.append(`Treatments[${index}].TreatmentName`, tr.treatmentName);
// 		treatmentFormData.append(`Treatments[${index}].TreatmentDescription`, tr.treatmentDescription ?? "");
// 		treatmentFormData.append(
// 			`Treatments[${index}].TreatmentTypeId`,
// 			!tr.treatmentTypeId || tr.treatmentTypeId === "" || tr.treatmentTypeId === "null" ? null : tr.treatmentTypeId
// 		);
// 		index++;
// 	}

// 	return fetch(`${aerialApiUri}api/v1/Trials/UpdateTrialTreatments?clientId=${clientId}`, {
// 		method: "PUT",
// 		headers: {
// 			Authorization: `Bearer ${accessToken}`
// 		},
// 		body: treatmentFormData
// 	})
// 		.then((res) => res.json())
// 		.then((data) => data);
// }

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function publishTrialFlight(clientId, trialId, flightId, trialOwnerUserId, accessToken) {
	let apiUrl = `${aerialApiUri}api/v1/Trials/PublishTrialFlight?clientId=${clientId}&trialId=${trialId}&flightId=${flightId}&trialOwnerUserId=${trialOwnerUserId}`;

	return fetch(apiUrl, {
		method: "POST",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => res.json())
		.then((data) => data);
}

export function publishTrialFlights(
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	clientId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	trialId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	trialName,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	flights,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	trialOwnerUserId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	flightScheduleId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	doNotPublishTrialFlights,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	accessToken,
) {
	let obj = {
		clientId: clientId,
		trialId: trialId,
		trialName: trialName,
		trialOwnerUserId: trialOwnerUserId,
		trialFlightsToPublish: flights,
		doNotPublishTrialFlights: doNotPublishTrialFlights,
		flightScheduleId: flightScheduleId,
	};

	let apiUrl = `${aerialApiUri}api/v1/Trials/PublishTrialFlights`;

	return fetch(apiUrl, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${accessToken}`,
		},
		body: JSON.stringify(obj),
	})
		.then((res) => res.json())
		.then((data) => data);
}

export function publishTrialFlightsToTrialSponsor(
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	clientId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	trialId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	trialName,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	flights,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	trialSponsorUserId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	flightScheduleId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	doNotPublishTrialFlights,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	accessToken,
) {
	let obj = {
		clientId: clientId,
		trialId: trialId,
		trialName: trialName,
		trialSponsorUserId: trialSponsorUserId,
		trialFlightsToPublish: flights,
		doNotPublishTrialFlights: doNotPublishTrialFlights,
		flightScheduleId: flightScheduleId,
	};

	let apiUrl = `${aerialApiUri}api/v1/Trials/PublishTrialFlightsToTrialSponsor`;

	return fetch(apiUrl, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${accessToken}`,
		},
		body: JSON.stringify(obj),
	})
		.then((res) => res.json())
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function publishTrialFlightToTrialSponsor(clientId, trialId, flightId, trialSponsorId, accessToken) {
	let apiUrl = `${aerialApiUri}api/v1/Trials/PublishTrialFlightToTrialSponsor?clientId=${clientId}&trialId=${trialId}&flightId=${flightId}&trialSponsorUserId=${trialSponsorId}`;

	return fetch(apiUrl, {
		method: "POST",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => res.json())
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function unpublishTrialFlights(clientId, trialId, flightIds, accessToken) {
	let obj = { clientId: clientId, trialId: trialId, flightIds: flightIds };
	let apiUrl = `${aerialApiUri}api/v1/Trials/UnpublishTrialsFlights`;

	return fetch(apiUrl, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${accessToken}`,
		},
		body: JSON.stringify(obj),
	})
		.then((res) => res.json())
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function unpublishTrialFlightsForTrialSponsor(clientId, trialId, flightIds, accessToken) {
	let obj = { clientId: clientId, trialId: trialId, flightIds: flightIds };
	let apiUrl = `${aerialApiUri}api/v1/Trials/UnpublishTrialFlightsForTrialSponsor`;

	return fetch(apiUrl, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${accessToken}`,
		},
		body: JSON.stringify(obj),
	})
		.then((res) => res.json())
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getTrialsPublishedToClientOrUser(clientId, accessToken) {
	return fetch(`${aerialApiUri}api/v1/Trials/GetTrialsPublishedToClientOrUser?clientId=${clientId}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function savePublishedTrialFlightClientIdAssignments(assignments, accessToken) {
	const assignmentsFormData = new FormData();

	let index = 0;
	for (const ass of assignments) {
		assignmentsFormData.append(`Assignments[${index}].TrialId`, ass.trialId);
		assignmentsFormData.append(`Assignments[${index}].FlightId`, ass.flightId);
		assignmentsFormData.append(`Assignments[${index}].PublishedToClientId`, ass.assignedToClientId);
		index++;
	}

	return fetch(`${aerialApiUri}api/v1/Trials/SetPublishedTrialFlightClientId`, {
		method: "POST",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
		body: assignmentsFormData,
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getTrialsPublishedByClient(clientId, accessToken) {
	return fetch(`${aerialApiUri}api/v1/Trials/GetTrialsPublishedByClient?clientId=${clientId}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

export function createDefaultViewerSettingForTrial(
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	clientId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	trialId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	toggleHeatmapData,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	toggleImageType,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	viewableFlightId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	viewableOrthoImageTypeId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	groundDatasetId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	groundDataAssessmentId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	curveModelAnalysisId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	analysisIdForCurveModel,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	analysisId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	analysisFlightId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	analysisTypeId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	quantifiedRegionTypeId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	accessToken,
) {
	const newDefaultViewerSettingFormData = new FormData();
	newDefaultViewerSettingFormData.set("trialId", trialId ?? "");
	newDefaultViewerSettingFormData.set("toggleHeatmapData", toggleHeatmapData ?? "");
	newDefaultViewerSettingFormData.set("toggleImageType", toggleImageType ?? "");
	newDefaultViewerSettingFormData.set("viewableFlightId", viewableFlightId ?? "");
	newDefaultViewerSettingFormData.set("viewableOrthoImageTypeId", viewableOrthoImageTypeId ?? "");
	newDefaultViewerSettingFormData.set("groundDatasetId", groundDatasetId ?? "");
	newDefaultViewerSettingFormData.set("groundDataAssessmentId", groundDataAssessmentId ?? "");
	newDefaultViewerSettingFormData.set("curveModelAnalysisId", curveModelAnalysisId ?? "");
	newDefaultViewerSettingFormData.set("analysisIdForCurveModel", analysisIdForCurveModel ?? "");
	newDefaultViewerSettingFormData.set("analysisId", analysisId ?? "");
	newDefaultViewerSettingFormData.set("analysisFlightId", analysisFlightId ?? "");
	newDefaultViewerSettingFormData.set("analysisTypeId", analysisTypeId ?? "");
	newDefaultViewerSettingFormData.set("quantifiedRegionTypeId", quantifiedRegionTypeId ?? "");

	return fetch(`${aerialApiUri}api/v1/Trials/CreateDefaultViewerSettingForTrial?clientId=${clientId}`, {
		method: "POST",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
		body: newDefaultViewerSettingFormData,
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

export function updateDefaultViewerSettingForTrial(
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	clientId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	id,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	trialId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	toggleHeatmapData,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	toggleImageType,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	viewableFlightId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	viewableOrthoImageTypeId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	groundDatasetId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	groundDataAssessmentId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	curveModelAnalysisId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	analysisIdForCurveModel,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	analysisId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	analysisFlightId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	analysisTypeId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	quantifiedRegionTypeId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	accessToken,
) {
	const targetDefaultViewerSettingFormData = new FormData();
	targetDefaultViewerSettingFormData.set("id", id ?? "");
	targetDefaultViewerSettingFormData.set("trialId", trialId ?? "");
	targetDefaultViewerSettingFormData.set("toggleHeatmapData", toggleHeatmapData ?? "");
	targetDefaultViewerSettingFormData.set("toggleImageType", toggleImageType ?? "");
	targetDefaultViewerSettingFormData.set("viewableFlightId", viewableFlightId ?? "");
	targetDefaultViewerSettingFormData.set("viewableOrthoImageTypeId", viewableOrthoImageTypeId ?? "");
	targetDefaultViewerSettingFormData.set("groundDatasetId", groundDatasetId ?? "");
	targetDefaultViewerSettingFormData.set("groundDataAssessmentId", groundDataAssessmentId ?? "");
	targetDefaultViewerSettingFormData.set("curveModelAnalysisId", curveModelAnalysisId ?? "");
	targetDefaultViewerSettingFormData.set("analysisIdForCurveModel", analysisIdForCurveModel ?? "");
	targetDefaultViewerSettingFormData.set("analysisId", analysisId ?? "");
	targetDefaultViewerSettingFormData.set("analysisFlightId", analysisFlightId ?? "");
	targetDefaultViewerSettingFormData.set("analysisTypeId", analysisTypeId ?? "");
	targetDefaultViewerSettingFormData.set("quantifiedRegionTypeId", quantifiedRegionTypeId ?? "");

	return fetch(`${aerialApiUri}api/v1/Trials/UpdateDefaultViewerSettingForTrial?clientId=${clientId}`, {
		method: "PUT",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
		body: targetDefaultViewerSettingFormData,
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function setPublishedTrialFlightViewed(qsPtfk, accessToken) {
	let apiUrl = `${aerialApiUri}api/v1/Trials/SetPublishedTrialFlightViewed?publishedKey=${qsPtfk}`;

	return fetch(apiUrl, {
		method: "POST",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => res.json())
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getTrialPublishingData(clientId, trialId, accessToken) {
	return fetch(`${aerialApiUri}api/v1/Trials/GetTrialPublishingData?clientId=${clientId}&trialId=${trialId}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getBulkTrialPublishingData(clientId, accessToken) {
	return fetch(`${aerialApiUri}api/v1/Trials/GetBulkTrialPublishingData?clientId=${clientId}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

export async function publishBulkTrialFlights(clientId: string, filteredBulkTrialData: any, accessToken: string) {
	let bulkTrialDataList: any[] = [];
	_.map(filteredBulkTrialData, (fbtd) => {
		let obj = {
			clientId: clientId,
			trialId: fbtd.trialId,
			trialName: fbtd.trialName,
			trialOwnerUserId: fbtd.trialOwnerUserId,
			trialSponsorUserId: fbtd.trialSponsorUserId,
			trialFlightsToPublish: fbtd.unPublishedTrialFlights,
			flightScheduleId: fbtd.flightScheduleId,
		};
		bulkTrialDataList.push(obj);
	});

	let apiUrl = `${aerialApiUri}api/v1/Trials/PublishBulkTrialFlights`;

	const res = await fetch(apiUrl, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${accessToken}`,
		},
		body: JSON.stringify(bulkTrialDataList),
	});
	const data = await res.json();
	return data;
}

export function setTrialOwnerEmailAddress(
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	emailAddress,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	trialId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	clientId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	trialOwnerClientId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	trialOwnerChangingTrialOwner,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	publishedToTrialOwner,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	fieldResearcherUserId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	trialSponsorUserId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	accessToken,
) {
	return fetch(
		`${aerialApiUri}api/v1/Trials/SetTrialOwnerEmailAddress
			?emailAddress=${emailAddress}
			&trialId=${trialId}
			&clientId=${clientId}
			${trialOwnerClientId ? `&trialOwnerClientId=${trialOwnerClientId}` : ""}
			&trialOwnerChangingTrialOwner=${trialOwnerChangingTrialOwner}
			&published=${publishedToTrialOwner}
			&fieldResearcherUserId=${fieldResearcherUserId}
			${trialSponsorUserId ? `&trialSponsorUserId=${trialSponsorUserId}` : ""}`,
		{
			method: "PUT",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	)
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

export function addTrialSponsorEmailAddress(
	emailAddress: string,
	trialId: string,
	clientId: string,
	granteeCompanyId: string | null | undefined,
	trialSponsorClientId: string | null | undefined,
	fieldResearcherUserId: string | null | undefined,
	trialOwnerUserId: string | null | undefined,
	accessToken: string,
) {
	return fetch(
		`${aerialApiUri}api/v1/Trials/AddTrialSponsorEmailAddress?emailAddress=${emailAddress}&trialId=${trialId}&clientId=${clientId}${granteeCompanyId ? `&granteeCompanyId=${granteeCompanyId}` : ""}
		${trialSponsorClientId ? `&trialSponsorClientId=${trialSponsorClientId}` : ""}
		&fieldResearcherUserId=${fieldResearcherUserId}${trialOwnerUserId ? `&trialOwnerUserId=${trialOwnerUserId}` : ""}`,
		{
			method: "POST",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	)
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

/**
 * Reads a field from the wire payload by either casing.
 *
 * `AddNewtonsoftJson()` leaves MVC's camelCase contract resolver in place, and every other call in
 * this file reads camelCase, so camelCase is what this endpoint is expected to send. The contract
 * for it was specified as PascalCase though, and guessing wrong fails silently rather than loudly:
 * `Clients` would read as absent, every lookup would look like an unknown email address, and the
 * organization picker would simply never appear. Reading both costs one helper.
 */
function readField<T>(data: Record<string, unknown>, name: string): T | undefined {
	const pascalCase = name.charAt(0).toUpperCase() + name.slice(1);
	return (data[name] ?? data[pascalCase]) as T | undefined;
}

/** One entry of the payload's client list, in whichever casing it arrived. */
type ClientAssociationWire = Record<string, unknown>;

/**
 * Normalizes the endpoint's payload to the camelCase the rest of the app uses.
 *
 * The endpoint answers 200 with `ApiMessages` rather than the view model when no user has that
 * email address, so a missing client list -- always present and populated on the view model -- is
 * what discriminates the two, not the status code.
 */
function normalizeClientAssociations(data: Record<string, unknown> | null): UserClientAssociations {
	const wireClients = data ? readField<ClientAssociationWire[]>(data, "clients") : undefined;

	if (!wireClients) {
		return {
			userId: null,
			personId: null,
			firstName: "",
			lastName: "",
			emailAddress: "",
			message: null,
			hasMultipleClients: false,
			clients: [],
			errors: (data ? readField<string[]>(data, "errors") : undefined) ?? [
				"Unable to look up the organizations for that email address.",
			],
		};
	}

	const payload = data as Record<string, unknown>;
	const clients = wireClients.map((c) => ({
		clientId: readField<string>(c, "clientId") ?? "",
		clientName: readField<string>(c, "clientName") ?? "",
	}));

	return {
		userId: readField<string>(payload, "userId") ?? null,
		personId: readField<string>(payload, "personId") ?? null,
		firstName: readField<string>(payload, "firstName") ?? "",
		lastName: readField<string>(payload, "lastName") ?? "",
		emailAddress: readField<string>(payload, "emailAddress") ?? "",
		message: readField<string>(payload, "message") ?? null,
		hasMultipleClients: readField<boolean>(payload, "hasMultipleClients") ?? clients.length > 1,
		clients,
		errors: null,
	};
}

/**
 * Looks up the organizations the user with `emailAddress` belongs to, so a trial can be assigned to
 * a specific one of them.
 *
 * Requires AP admin/support, which is stricter than the `SetTrialOwnerEmailAddress` /
 * `AddTrialSponsorEmailAddress` calls this precedes: a TrialEdit user who is not admin/support gets
 * a 401 here while the assignment itself still succeeds. Callers must treat the lookup as optional
 * and assign without it rather than blocking on it.
 *
 * `clientId` is the caller's current client and feeds the client-switch audit log only; it does not
 * filter the results.
 */
export async function getClientAssociationsForEmailAddress(
	emailAddress: string,
	clientId: string,
	accessToken: string,
): Promise<UserClientAssociations> {
	const res = await fetch(
		`${aerialApiUri}api/v1/Trials/GetClientAssociationsForEmailAddress?emailAddress=${encodeURIComponent(
			emailAddress,
		)}&clientId=${encodeURIComponent(clientId)}`,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	);

	const data = (await res.json()) as Record<string, unknown> | null;
	return normalizeClientAssociations(data);
}

export function getTrialSponsors(trialId: string, clientId: string, accessToken: string) {
	return fetch(`${aerialApiUri}api/v1/Trials/GetTrialSponsors?trialId=${trialId}&clientId=${clientId}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => res.json())
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function sendNewUserEmail(emailAddress, clientName, clientId, accessToken) {
	return fetch(
		`${aerialApiUri}api/v1/Trials/SendNewUserEmail?emailAddress=${emailAddress}&clientName=${clientName}&clientId=${clientId}`,
		{
			method: "POST",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	)
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

// export function getSoilFertilityOptions(clientId, accessToken) {
// 	return fetch(`${aerialApiUri}api/v1/Trials/GetSoilFertilityOptions?clientId=${clientId}`, {
// 		method: "GET",
// 		headers: {
// 			Authorization: `Bearer ${accessToken}`
// 		}
// 	})
// 		.then((res) => res.json())
// 		.then((data) => data);
// }

// export function getSoilFertilityDataForTrial(trialId, clientId, accessToken) {
// 	return fetch(`${aerialApiUri}api/v1/Trials/GetSoilFertilityDataForTrial?trialId=${trialId}&clientId=${clientId}`, {
// 		method: "GET",
// 		headers: {
// 			Authorization: `Bearer ${accessToken}`
// 		}
// 	})
// 		.then((res) => res.json())
// 		.then((data) => data);
// }

// export function createSoilFertilityDataFromTrial(soilFertility, trialId, clientId, accessToken) {
// 	const soilFertilityFormData = new FormData();

// 	soilFertilityFormData.set("FertilityId", soilFertility.fertilityId);
// 	soilFertilityFormData.set("DrainageId", soilFertility.drainageId);
// 	soilFertilityFormData.set("SoilSeriesName", soilFertility.soilSeriesName);
// 	soilFertilityFormData.set("TextureId", soilFertility.textureId);
// 	soilFertilityFormData.set("SandRatio", soilFertility.sandRatio);
// 	soilFertilityFormData.set("SiltRatio", soilFertility.siltRatio);
// 	soilFertilityFormData.set("ClayRatio", soilFertility.clayRatio);
// 	soilFertilityFormData.set("OMRatio", soilFertility.omRatio);
// 	soilFertilityFormData.set("pHLevel", soilFertility.pHLevel);
// 	soilFertilityFormData.set("CECLevel", soilFertility.cecLevel);
// 	soilFertilityFormData.set("nitrogenLevel", soilFertility.nitrogenLevel);
// 	soilFertilityFormData.set("phosphorusLevel", soilFertility.phosphorusLevel);
// 	soilFertilityFormData.set("potassiumLevel", soilFertility.potassiumLevel);

// 	return fetch(
// 		`${aerialApiUri}api/v1/Trials/CreateSoilFertilityDataFromTrial?trialId=${trialId}&clientId=${clientId}`,
// 		{
// 			method: "POST",
// 			headers: {
// 				Authorization: `Bearer ${accessToken}`
// 			},
// 			body: soilFertilityFormData
// 		}
// 	)
// 		.then((res) => res.json())
// 		.then((data) => data);
// }

// export function updateSoilFertilityData(soilFertility, soilFertilityId, clientId, accessToken) {
// 	const soilFertilityFormData = new FormData();

// 	soilFertilityFormData.set("FertilityId", soilFertility.fertilityId);
// 	soilFertilityFormData.set("DrainageId", soilFertility.drainageId);
// 	soilFertilityFormData.set("SoilSeriesName", soilFertility.soilSeriesName);
// 	soilFertilityFormData.set("TextureId", soilFertility.textureId);
// 	soilFertilityFormData.set("SandRatio", soilFertility.sandRatio);
// 	soilFertilityFormData.set("SiltRatio", soilFertility.siltRatio);
// 	soilFertilityFormData.set("ClayRatio", soilFertility.clayRatio);
// 	soilFertilityFormData.set("OMRatio", soilFertility.omRatio);
// 	soilFertilityFormData.set("pHLevel", soilFertility.pHLevel);
// 	soilFertilityFormData.set("CECLevel", soilFertility.cecLevel);
// 	soilFertilityFormData.set("nitrogenLevel", soilFertility.nitrogenLevel);
// 	soilFertilityFormData.set("phosphorusLevel", soilFertility.phosphorusLevel);
// 	soilFertilityFormData.set("potassiumLevel", soilFertility.potassiumLevel);

// 	return fetch(
// 		`${aerialApiUri}api/v1/Trials/UpdateSoilFertilityData?soilFertilityId=${soilFertilityId}&clientId=${clientId}`,
// 		{
// 			method: "PUT",
// 			headers: {
// 				Authorization: `Bearer ${accessToken}`
// 			},
// 			body: soilFertilityFormData
// 		}
// 	)
// 		.then((res) => res.json())
// 		.then((data) => data);
// }

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getTrialPlotsForMapping(trialId, clientId, accessToken) {
	return fetch(`${aerialApiUri}api/v1/Trials/GetTrialPlotsForMapping?trialId=${trialId}&clientId=${clientId}`, {
		method: "GET",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => res.json())
		.then((data) => data);
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getMetadataForTrials(trials, currentClientId, accessToken) {
	return fetch(`${aerialApiUri}api/v1/Trials/GetMetadataForTrials?clientId=${currentClientId}`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${accessToken}`,
		},
		body: JSON.stringify(trials),
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

export function getPlotAnalysisStatusForTrial(
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	trialId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	clientId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	analysisId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	curveModelAnalysisId,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	checkFlights,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	checkCurveModels,
	// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
	accessToken,
) {
	return fetch(
		`${aerialApiUri}api/v1/Trials/GetPlotAnalysisStatusForTrial
		?trialId=${trialId}
		&clientId=${clientId}
		&analysisId=${analysisId ?? ""}
		&curveModelAnalysisId=${curveModelAnalysisId ?? ""}
		&checkFlights=${checkFlights}
		&checkCurveModels=${checkCurveModels}`,
		{
			method: "GET",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	)
		.then((res) => res.json())
		.then((data) => data);
}

export async function fetchPlotAnalysisStatusForTrial(
	trialId: string,
	clientId: string,
	accessToken: string,
	analysisId: string = "",
	curveModelAnalysisId: string = "",
	checkFlights = true,
	checkCurveModels = true,
) {
	const res = await fetch(
		`${aerialApiUri}api/v1/Trials/GetPlotAnalysisStatusForTrial
		?trialId=${trialId}
		&clientId=${clientId}
		&analysisId=${analysisId}
		&curveModelAnalysisId=${curveModelAnalysisId}
		&checkFlights=${checkFlights}
		&checkCurveModels=${checkCurveModels}`,
		{
			method: "GET",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	);

	if (!res.ok) {
		throw new Error("failed to fetch analysis status");
	}
	const data = res.json() as Promise<object>;
	return data;
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function updateTrialTreatments(clientId, treatments, accessToken) {
	const treatmentFormData = new FormData();

	treatmentFormData.set("ClientId", clientId);
	let index = 0;
	for (const tr of treatments) {
		treatmentFormData.append(`Treatments[${index}].TreatmentId`, tr.treatmentId);
		treatmentFormData.append(`Treatments[${index}].TrialTreatmentId`, tr.trialTreatmentId);
		treatmentFormData.append(`Treatments[${index}].TreatmentName`, tr.treatmentName);
		treatmentFormData.append(`Treatments[${index}].TreatmentDescription`, tr.treatmentDescription);
		treatmentFormData.append(
			`Treatments[${index}].TreatmentTypeId`,
			!tr.treatmentTypeId || tr.treatmentTypeId === "" || tr.treatmentTypeId === "null" ? null : tr.treatmentTypeId,
		);
		treatmentFormData.append(
			`Treatments[${index}].Seed`,
			!tr.seed || tr.seed === "" || tr.seed === "null" ? null : tr.seed,
		);
		index++;
	}

	return fetch(`${aerialApiUri}api/v1/Trials/UpdateTrialTreatments`, {
		method: "PUT",
		headers: { Authorization: `Bearer ${accessToken}` },
		body: treatmentFormData,
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

// For use with redux action
// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function getAnnotationSummaryForTrial(trialId, currentClientId, accessToken) {
	return fetch(
		`${aerialApiUri}api/v1/Trials/GetAnnotationSummaryForTrial?trialId=${trialId}&clientId=${currentClientId}`,
		{
			method: "GET",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	)
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

// For use with useQuery
export async function getAnnotationSummaryForTrialAsync(
	trialId: string,
	currentClientId: string,
	accessToken: string,
): Promise<AerialPlotResponse<any>> {
	const res = await fetch(
		`${aerialApiUri}api/v1/Trials/GetAnnotationSummaryForTrial?trialId=${trialId}&clientId=${currentClientId}`,
		{
			method: "GET",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	);
	if (!res.ok) {
		throw new Error("failed to fetch annotation summary");
	}
	const data = res.json() as Promise<AerialPlotResponse<any>>;

	return data;
}

export type MetaTagOptions = {
	trialDataQualities: Option[];
	trialExclusionStatuses: Option[];
	trialSiteResponses: Option[];
	userReviewStatuses: Option[];
};

export async function getTrialMetaTagOptions(
	clientId: string,
	accessToken: string,
): Promise<AerialPlotResponse<MetaTagOptions>> {
	const res = await fetch(`${aerialApiUri}api/v1/Trials/GetTrialMetaTagOptions?clientId=${clientId}`, {
		method: "GET",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	});
	if (!res.ok) {
		throw new Error("failed to fetch options");
	}
	const data = res.json() as Promise<AerialPlotResponse<MetaTagOptions>>;
	return data;
}

export type MetaFactorData = {
	trialDataQualityId: string;
	trialExclusionStatusId: string;
	trialSiteResponseId: string;
	userReviewStatusId: string;
	reviewedByUserName: string;
	reviewedDateTimeUtc: Date;
	notes: string;
	hasExcludedSubsample: boolean;
	countPlotsFlagged: number;
	countPlotsExcluded: number;
	countRepsExcluded: number;
};

export async function getTrialMetaFactorData(
	trialId: string,
	clientId: string,
	accessToken: string,
): Promise<AerialPlotResponse<MetaFactorData>> {
	const res = await fetch(
		`${aerialApiUri}api/v1/Trials/GetTrialMetaFactorData?clientId=${clientId}&trialId=${trialId}`,
		{
			method: "GET",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	);
	if (!res.ok) {
		throw new Error("failed to fetch meta factors");
	}
	const data = res.json();
	return data as Promise<AerialPlotResponse<MetaFactorData>>;
}

export type MetaTagsUpdateInfo = {
	trialId: string;
	trialDataQualityId: string;
	trialExclusionStatusId: string;
	trialSiteResponseId: string;
	userReviewStatusId: string | null;
	trialNotes: string;
	trialName?: string;
	isForProtocol?: boolean;
};

export async function updateTrialMetaTags(
	updateInfo: MetaTagsUpdateInfo,
	clientId: string,
	accessToken: string,
): Promise<AerialPlotResponse<void>> {
	const updateInfoFormData = new FormData();
	for (const name in updateInfo) {
		if (name !== "treatments") {
			// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
			let val = updateInfo[name] === "" ? null : updateInfo[name];

			//-- Need to specifically check for the name isEstimatedPlantDate because it has the word "date" in it but it should not be treated as a date
			if (name.match(/date/gim) && name !== "isEstimatedPlantDate" && val) {
				val = val.toLocaleDateString();
			}

			if (val) {
				updateInfoFormData.set(name, val);
			}
		}
	}

	const res = await fetch(`${aerialApiUri}api/v1/Trials/UpdateTrialMetaTags?clientId=${clientId}`, {
		method: "PUT",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
		body: updateInfoFormData,
	});
	if (!res.ok) {
		throw new Error("failed to update meta tags");
	}
	const data = res.json();
	return data as Promise<AerialPlotResponse<void>>;
}

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
export function removeTrialOwner(trialId, clientId, accessToken) {
	return fetch(`${aerialApiUri}api/v1/Trials/RemoveTrialOwner?trialId=${trialId}&clientId=${clientId}`, {
		method: "PUT",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => res.json())
		.then((data) => data);
}

export function removeTrialSponsor(
	trialId: string,
	clientId: string,
	granteeUserId: string,
	granteeClientId: string | null | undefined,
	accessToken: string,
) {
	return fetch(
		`${aerialApiUri}api/v1/Trials/RemoveTrialSponsor?trialId=${trialId}&clientId=${clientId}&granteeUserId=${granteeUserId}${
			granteeClientId ? `&granteeClientId=${granteeClientId}` : ""
		}`,
		{
			method: "DELETE",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	)
		.then((res) => res.json())
		.then((data) => data);
}

export async function fetchTrialAnalysisDataOptions(trialId: string, clientId: string, accessToken: string) {
	const res = await fetch(
		`${aerialApiUri}api/v1/Trials/TrialAnalysisDataOptions?clientId=${clientId}&trialId=${trialId}`,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	);

	if (!res.ok) {
		throw new Error("failed to fetch options");
	}
	const data = (await res.json()) as AerialPlotResponse<TrialAnalysisDataOptions>;
	return data.data;
}

export async function fetchSummaryTableDataOptions(trialId: string, clientId: string, accessToken: string) {
	const res = await fetch(
		`${aerialApiUri}api/v1/Trials/SummaryTableDataOptions?clientId=${clientId}&trialId=${trialId}`,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	);

	if (!res.ok) {
		throw new Error("failed to fetch options");
	}
	const data = (await res.json()) as AerialPlotResponse<TrialAnalysisDataOptions>;
	return data.data;
}

export async function fetchTrialData(clientId: string, trialId: string, accessToken: string): Promise<TrialData> {
	const res = await fetch(aerialApiUri + `api/v1/Trials?clientId=${clientId}&trialId=${trialId}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	});

	if (!res.ok) {
		throw new Error("failed to fetch trial data");
	}

	const data = (await res.json()) as TrialData;
	return data;
}
